import { ContentWorkflow } from '@amzn/awscat-pattern-library-service-model';
import { Container, Header, SpaceBetween, Spinner } from '@amzn/awsui-components-core';
import React, { useEffect, useMemo, useState } from 'react';
import ContentInfoDetails from './ContentInfoDetails';
import ContentNotesDetails from './ContentNotesDetails';
import { RouteComponentProps, withRouter } from 'react-router';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import { IMplServiceClient } from '../../api/IMplServiceClient';
import Breadcrumbs from '../common/Breadcrumbs';
import constants from '../../common/constants';

interface ContentNotesViewerProps extends RouteComponentProps<{ contentId: string }> {}

const mplServiceClient: IMplServiceClient = MplServiceClientFactory.create();

const ContentNotesViewer: React.FunctionComponent<ContentNotesViewerProps> = (
  props: ContentNotesViewerProps,
) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [workflow, setWorkflow] = useState<ContentWorkflow>();

  useEffect(() => {
    const fetchContentWorkflow = async () => {
      setIsLoading(true);
      const contentWorkflow = await mplServiceClient.getContentWorkflow(
        props.match.params.contentId,
      );
      setWorkflow(contentWorkflow?.workflow);
      setIsLoading(false);
    };
    fetchContentWorkflow();
  }, [props.match.params.contentId]);

  const breadcrumbItems = [
    { text: constants.APP_NAME_BREAD_CRUMB, href: '/' },
    { text: constants.TECH_WRITER_BREAD_CRUMB, href: '/tech-writer/dashboard-new' },
    { text: constants.DASHBOARD, href: '' },
  ];

  return isLoading ? (
    <Spinner />
  ) : (
    <SpaceBetween direction="vertical" size="s">
      <Breadcrumbs items={breadcrumbItems} />
      <Container
        className="content-notes"
        header={<Header variant="h3">{constants.TECH_WRITER_NOTES_HEADER}</Header>}
      >
        <SpaceBetween direction="vertical" size="s">
          {/* @ts-expect-error TS2322 - strict migration */}
          <ContentInfoDetails workflow={workflow} />
          {/* @ts-expect-error TS2322 - strict migration */}
          <ContentNotesDetails workflow={workflow} showAllNotes />
        </SpaceBetween>
      </Container>
    </SpaceBetween>
  );
};

export default withRouter(ContentNotesViewer);
